import {
  GET_REVIEW_DETAIL,
  GET_REVIEW_DETAIL_SUCCESS,
  GET_REVIEW_DETAIL_FAILURE,
} from 'store/registerReview/registerReviewAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const getReviewDetailReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_REVIEW_DETAIL:
      return { ...state, loading: true };
    case GET_REVIEW_DETAIL_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case GET_REVIEW_DETAIL_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default getReviewDetailReducer;
